__turbopack_context__.v({
  "header": "PlasmicMyEvalsHeader-module__hbovya__header",
  "logo": "PlasmicMyEvalsHeader-module__hbovya__logo",
});
